import { usePageLayout } from '../Context/PageLayoutContext';

export const usePageLayoutContent = () => {
  const { content, snackbar, setSnackbarState, pageTitle } = usePageLayout();

  return {
    content,
    snackbar,
    setSnackbarState,
    pageTitle,
  };
};
